/* rt: proteção de envio do cart drawer (snippets/rt-cart-protection.liquid).
   Ligar/desligar = pôr/tirar o produto do carrinho e marcar o atributo _rt_protection (on/off).
   Em cada mudança do carrinho: com artigos e sem proteção, e o bloco "ligado por omissão" e o
   cliente sem a ter desligado → adiciona; sem artigos → tira; mais de 1 → volta a 1. */
(function () {
  if (window.rtCartProtection) return;
  window.rtCartProtection = true;

  let busy = false;
  let failed = false;
  const root = () => document.querySelector('[data-rt-protection]');

  function update(el, qty, state) {
    busy = true;
    el.classList.add('is-busy');
    const body = { updates: { [el.dataset.variant]: qty } };
    if (state) body.attributes = { _rt_protection: state };
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then((r) => {
        if (!r.ok) throw new Error('/cart/update.js ' + r.status);
        busy = false;
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        sync();
      })
      .catch((err) => {
        // sem nova tentativa automática: um produto indisponível daria um ciclo de pedidos
        failed = true;
        busy = false;
        console.warn('rt-cart-protection:', err);
      })
      .finally(() => el.classList.remove('is-busy'));
  }

  function sync() {
    const el = root();
    if (!el || busy || failed || (window.Shopify && window.Shopify.designMode)) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        if (busy) return;
        const pid = parseInt(el.dataset.product, 10);
        let prot = 0;
        let real = 0;
        cart.items.forEach((i) => {
          if (i.product_id === pid) prot += i.quantity;
          else real += i.quantity;
        });
        const input = el.querySelector('[data-rt-protection-input]');
        if (input) input.checked = prot > 0;
        if (real === 0 && prot > 0) return update(el, 0);
        if (prot > 1) return update(el, 1);
        const off = cart.attributes && cart.attributes._rt_protection === 'off';
        if (real > 0 && prot === 0 && el.dataset.defaultOn === 'true' && !off) {
          if (input) input.checked = true;
          return update(el, 1);
        }
      })
      .catch((err) => console.warn('rt-cart-protection: /cart.js falhou', err));
  }

  document.addEventListener('change', (e) => {
    if (!e.target.matches || !e.target.matches('[data-rt-protection-input]')) return;
    const el = e.target.closest('[data-rt-protection]');
    if (el) update(el, e.target.checked ? 1 : 0, e.target.checked ? 'on' : 'off');
  });
  document.addEventListener('theme:cart:change', sync);
  document.addEventListener('theme:cart-drawer:open', sync);
  sync();
})();
